import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
// core components
import headerStyle from "assets/jss/material-kit-react/components/headerStyle.jsx";
import { SignalCellularConnectedNoInternet0BarRounded } from "@material-ui/icons";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import $ from 'jquery';
import ListItem from "@material-ui/core/ListItem";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false

    };
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
    this.headerColorChange = this.headerColorChange.bind(this);
  }
  handleDrawerToggle() {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  }
  componentDidMount() {
    if (this.props.changeColorOnScroll) {
      window.addEventListener("scroll", this.headerColorChange);
    }
  }
  headerColorChange() {
    const { classes, color, changeColorOnScroll } = this.props;
    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
    }
  }

  componentWillUnmount() {
    if (this.props.changeColorOnScroll) {
      window.removeEventListener("scroll", this.headerColorChange);
    }
  }


  render() {
    const {
      classes,
      color,
      rightLinks,
      leftLinks,
      brand,
      brands,
      fixed,
      dataType, selectTab, changeLoginType,
      absolute,
    } = this.props;
    const appBarClasses = classNames({
      [classes.appBar]: true,
      [classes[color]]: color,
      [classes.absolute]: absolute,
      [classes.fixed]: fixed
    });
    const brandComponent = <Button className={classes.title}>{brand}</Button>;


    function handleTabClick(event) {
      console.log("Header.jsx");
      var nowTab = dataType.currentTab;
      selectTab(event.currentTarget.getAttribute("tab"));
      var move = event.currentTarget.getAttribute("move");
      var link = event.currentTarget.getAttribute("link");
      if (move && move != "TOP") {

        if (dataType.currentTab == "Home" && nowTab == "Home") {
          $('html,body').animate({ scrollTop: $('#' + move).offset().top }, 800);
        }
        else {
          $('html,body').animate({ scrollTop: 0 }, 800, function () { $('html,body').animate({ scrollTop: $('#' + move).offset().top }, 800); })
          //setTimeout(function () {  $('html,body').animate({ scrollTop: $('#' + move).offset().top }, 800); }, 500);
        }

      }
      else if (move == "TOP") {
        $('html,body').animate({ scrollTop: 0 }, 800);
      }

      if (link) {
        // download(link);
        window.open(link, '_blank');
        // window.open(link,'_blank')

      }


    }

    // function download(src) {
    //   var $form = $('<form method="GET"></form>');
    //   $form.attr('action', src);
    //   $form.appendTo($('body'));
    //   $form.submit();
    //   }


    //Modified 20190910 修改上方頁籤
    var menuItem = brands.map((page, pageIndex) => {
      // (<Button className={classes.title} key={page.ID} tab={page.TAB} move={page.DIV} onClick={handleTabClick} disabled={page.TAB !== "Home" && !dataType.isLogin}   style={{ display: (dataType.isMobile&&!page.MOBILE) ? 'none' : {} }} href={page.LINK}  >{page.Name}</Button>)
      const imgstyle = { 'max-width': '125px','padding-bottom': '20px' };
      if (page.Type === "Button") {
        return  <Button className={classes.title} key={page.ID} tab={page.TAB} move={page.DIV} onClick={handleTabClick} disabled={page.TAB !== "Home" && !dataType.isLogin} style={{ display: (dataType.isMobile && !page.MOBILE) ? 'none' : {} }} href={page.LINK}  >{page.Name}</Button>
      }
      else {
    
        return <img src={page.LINK} style={imgstyle} />
      }
    }
    );

    // var menuMobileItem = brands.map((page, pageIndex) =>
    //   (<ListItem className={classes.listItem}><Button className={classes.title} key={page.ID} tab={page.TAB} move={page.DIV} onClick={handleTabClick} disabled={page.TAB !== "Home" && !dataType.isLogin} style={{ display: (dataType.isMobile && !page.MOBILE) ? {} : 'none' }} href={page.LINK}  >{page.Name}</Button> </ListItem>));

    var menuMobileItem = brands.map((page, pageIndex) =>{
  
      const imgstyle = { 'max-width': '125px' };
      if (page.Type === "Button") {
        return  <ListItem className={classes.listItem}><Button className={classes.title} key={page.ID} tab={page.TAB} move={page.DIV} onClick={handleTabClick} disabled={page.TAB !== "Home" && !dataType.isLogin} style={{ display: (dataType.isMobile && !page.MOBILE) ? {} : 'none' }} href={page.LINK}  >{page.Name}</Button> </ListItem>

      }
      else {
        return <ListItem className={classes.listItem}><img src={page.LINK} style={imgstyle} /> </ListItem>
      }
    }
    );


    return (


      <AppBar className={appBarClasses}>
        <Toolbar className={classes.container}>
          <div className={classes.flex}>
            {/* <GridContainer className={classes.title}>
              <GridItem >OneGrade</GridItem>
              <GridItem >閱卷專家</GridItem>
            </GridContainer> */}

            {menuItem}
          </div>
          {rightLinks}
          {/* {leftLinks !== undefined ? brandComponent : null}
          <div className={classes.flex}>
            {leftLinks !== undefined ? (
              <Hidden smDown implementation="css">
                {leftLinks}
              </Hidden>
            ) : (
              
              menuItem
            )}
            
          </div>
          {rightLinks} */}
          {/* <Hidden smDown implementation="css">
            {rightLinks}
          </Hidden> */}
          <Hidden mdUp>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={this.handleDrawerToggle}
            >
              <Menu />
            </IconButton>
          </Hidden>
        </Toolbar>
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={"right"}
            open={this.state.mobileOpen}
            classes={{
              paper: classes.drawerPaper
            }}
            onClose={this.handleDrawerToggle}
          >
            <div className={classes.appResponsive}>
              {/* {leftLinks} */}
              {/* {rightLinks} */}
              {menuMobileItem}
            </div>
          </Drawer>
        </Hidden>
      </AppBar >
    );
  }
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),
  rightLinks: PropTypes.node,
  leftLinks: PropTypes.node,
  brand: PropTypes.string,
  // brands :PropTypes.node,
  // brandSelect :PropTypes.string, 
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // this.props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // this.props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark"
    ]).isRequired
  })
};

export default withStyles(headerStyle)(Header);



// WEBPACK FOOTER //
// ./src/views/HomePage/Sections/Header/Header.jsx